<template>
    <span> {{ current_text }} </span>
</template>

<script>
export default {
    name: 'easy-typer',
    props: {
        text: {
            type: String,
            required: true
        },
        autostart: {
            type: Boolean,
            default: true
        },
        time: {
            type: Number
        }
    },
    data() {
        return {
            i: 0,
            current_text: ""
        }
    },
    mounted() {
        if(this.autostart) {
            this.start();
        }
    },
    methods: {
        start() {
            this.addLetter();
        },
        addLetter() { 
            if(this.i >= this.text.length ) return;
            this.current_text += this.text[this.i];
            this.i++; 
            setTimeout(this.addLetter.bind(this), this.time/this.text.length );
        }
    }
}
</script>

<style scoped>

span {
    color: inherit;
}

</style>